/**
 * Models a tooltip, which is implemented by the UI as a custom renderer.
 */

import Brace from "backbone.brace";
import StringKeyValueCollection from "../collections/key-string-value";

// plain tooltip
const Tooltip = Brace.Model.extend({
  namedAttributes: {
    value: String,
    tooltip: StringKeyValueCollection,
  },
  defaults: {
    value: null,
    tooltip: new StringKeyValueCollection(),
  },
});

// typed tooltip, used by HCC Categories Meta
export const TypedTooltip = Tooltip.extend({
  namedAttributes: {
    type: String,
  },
});

export { Tooltip as default };
